import * as Sentry from "@sentry/react"

import { env } from "@/lib/env"

if (env.sentryDsn) {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.sentryEnvironment,
    release: env.sentryRelease,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [/^\//],
    tracesSampleRate: env.isProduction ? 0.15 : 1,
    replaysSessionSampleRate: env.isProduction ? 0.05 : 1,
    replaysOnErrorSampleRate: 1,
  })
}
